import { Firm, Modifier } from '@eo-storefronts/eo-core'
import useModifierMediaTemplateService
  from '~/src/components/products/modifier-groups/modifier-group/modifier/modifier-media/styles/useModifierMediaTemplateService'
import { useEoValue } from '~/src/hooks/useEoState'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import { LANGUAGE_STATE } from '~/src/stores/lang'
import Image from '~/src/components/mui-wrappers/Image'

interface Props {
  modifier: Modifier,
  rounded?: boolean,
}

const ModifierMedia = ({ modifier, rounded = true }: Props) => {
  const firm: Firm | null = useEoValue(FIRM_SELECTOR)
  const lang = useEoValue(LANGUAGE_STATE)
  const styles = useModifierMediaTemplateService()

  if (!firm?.settings.theme?.show_modifier_images || !modifier.images?.length) {
    return null
  }

  return (
    <Image
      src={modifier.images[0].thumb}
      alt={`${modifier.name[lang]}-image`}
      sx={styles.getContainerSx(rounded)}
    />
  )
}

export default ModifierMedia
